// Sovereign Obsidian, Notion & Markdown Vault Exporter
// Converts MeMark bookmark archive into bidirectional Markdown documents with YAML frontmatter

export function generateObsidianMarkdown(items = [], folders = []) {
  const folderMap = {};
  folders.forEach(f => {
    folderMap[f.id] = f.name;
  });

  const timestamp = new Date().toISOString().split('T')[0];
  let md = `---
vault: "MeMark Sovereign Archive"
exported_at: "${timestamp}"
total_bookmarks: ${items.length}
total_folders: ${folders.length}
generator: "MeMark Sovereign Cyberpunk Engine v2.4"
---

# 🌌 MeMark Sovereign Obsidian Vault

> Exported on **${timestamp}** from [MeMark](https://app.memark.me/).
> Fully compatible with **Obsidian**, **Logseq**, **Notion**, and raw markdown viewers.

---

## 📑 Table of Contents

- [Root Archive](#root-archive)
`;

  folders.forEach(f => {
    const slug = f.name.toLowerCase().replace(/[^a-z0-9]+/g, '-');
    md += `- [📂 ${f.name}](#-${slug})\n`;
  });

  md += `\n---\n\n## 🗄️ Root Archive\n\n`;

  const rootItems = items.filter(it => !it.folder_id && !it.folderId);
  if (rootItems.length === 0) {
    md += `*No items in root archive.*\n\n`;
  } else {
    rootItems.forEach(it => {
      md += renderItemCard(it, 'Root');
    });
  }

  folders.forEach(folder => {
    const slug = folder.name.toLowerCase().replace(/[^a-z0-9]+/g, '-');
    const folderItems = items.filter(it => it.folder_id === folder.id || it.folderId === folder.id);
    md += `\n---\n\n## 📂 ${folder.name}\n\n`;
    if (folderItems.length === 0) {
      md += `*Folder is currently empty.*\n\n`;
    } else {
      folderItems.forEach(it => {
        md += renderItemCard(it, folder.name);
      });
    }
  });

  return md;
}

function renderItemCard(it, folderName) {
  const tags = (it.tags || []).map(t => t.startsWith('#') ? t : `#${t}`).join(', ') || '#bookmark';
  const cleanUrl = it.url || '#';
  const title = it.title || 'Untitled';
  const note = it.notes || it.description || 'No notes attached.';
  const clicks = it.clicks || 0;

  return `### [${title}](${cleanUrl})
\`\`\`yaml
title: "${title.replace(/"/g, '\\"')}"
url: "${cleanUrl}"
folder: "${folderName}"
tags: [${tags}]
clicks: ${clicks}
created: "${it.created_at || '2026-10-20'}"
\`\`\`
> ${note}

- **URL**: [${cleanUrl}](${cleanUrl})
- **Folder**: \`${folderName}\`
- **Telemetry**: \`⚡ ${clicks} hits\`
- **Tags**: ${tags}

---

`;
}

export function downloadObsidianVault(items = [], folders = []) {
  const markdownContent = generateObsidianMarkdown(items, folders);
  const blob = new Blob([markdownContent], { type: 'text/markdown;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const dateStr = new Date().toISOString().split('T')[0];
  const a = document.createElement('a');
  a.href = url;
  a.download = `MeMark-Vault-Obsidian-${dateStr}.md`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
